import { Injectable, isDevMode } from '@angular/core';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { UserService } from '../../user-service/user.service';
import { DashboardCenter } from 'src/app/models/dashboard-models/dasboard-center.model';
import { DashboardDaoService } from 'src/app/dao/dashboard-dao-service/dashboard-dao.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { DashboardBroadcastingActivity } from 'src/app/models/dashboard-models/dasboard-broadcasting-activity.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardBroadcastService {

  accessToken = ['DHB', 'BRO'];

  constructor(
    private userService: UserService,
    private userStorageService: UserStorageService,
    private dashboardDaoService: DashboardDaoService
  ) { }

  public getActivity(datetimeFrom, datetimeTo, centerInternalIdList) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.dashboardDaoService.getBroadcastActivity(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        datetimeFrom,
        datetimeTo,
        centerInternalIdList
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const broadcastActiviy = new DashboardBroadcastingActivity();
          Object.assign(broadcastActiviy, o['data']['result']);
          return broadcastActiviy;
        })
      );
    }
    return EMPTY;
  }

  public getActivityDetails(datetimeFrom, datetimeTo, centerInternalIdList) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.dashboardDaoService.getBroadcastActivityDetails(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        datetimeFrom,
        datetimeTo,
        centerInternalIdList
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          return o['data']['success'];
        })
      );
    }
    return EMPTY;
  }

}
